import md5 from './md5';
export default function gravatar(email, size = 64) {
  return `https://secure.gravatar.com/avatar/${md5(email)}?s=${size}&d=identicon&r=PG`;
}
